import React from 'react';
import { useInlineEdit } from '@/contexts/InlineEditContext';
import { Pencil, PencilOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const InlineEditToggle = () => {
  const { editMode, toggleEditMode, isAdmin } = useInlineEdit();

  if (!isAdmin) return null;

  return (
    <AnimatePresence>
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        onClick={toggleEditMode}
        data-cms-skip
        className={`fixed bottom-24 left-5 z-[9999] w-12 h-12 flex items-center justify-center shadow-xl transition-colors ${
          editMode
            ? 'bg-[#E63946] text-white'
            : 'bg-[#1a1a1a] text-gray-400 border border-white/20 hover:border-[#E63946]/50 hover:text-[#E63946]'
        }`}
        title={editMode ? 'Exit edit mode' : 'Edit page content'}
        data-testid="inline-edit-toggle"
      >
        {editMode ? <PencilOff className="w-5 h-5" /> : <Pencil className="w-5 h-5" />}
      </motion.button>
      {editMode && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}
          className="fixed bottom-[108px] left-5 z-[9999] bg-[#E63946] text-white text-xs font-medium px-3 py-1.5 shadow-xl whitespace-nowrap"
          data-testid="inline-edit-badge"
        >
          EDIT MODE
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InlineEditToggle;
